import IPaymentSplit from '@/interfaces/PaymentSplit';
import PaymentSummary from '@/interfaces/PaymentSummary';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const usePaymentStore = defineStore('payment', () => {
  const summary = ref<PaymentSummary>({
    amount: 0,
    taxFree: 0,
    tax: 0,
    deposit: 0,
    preTip: 0,
    splits: [],
  });

  // 남은 결제 금액
  const remainingAmount = computed(
    () => summary.value.amount - summary.value.splits.reduce((acc, split) => acc + split.amount, 0),
  );

  /**
   * 결제 금액 데이터 설정
   * @param value 결제 금액 데이터
   */
  const setSummary = (value: PaymentSummary) => {
    summary.value = value;
  };

  /**
   * 결제 금액 분할 데이터 추가
   * @param value 결제 금액 분할 데이터
   */
  const addPaymentSplit = (value: IPaymentSplit) => {
    summary.value.splits.push(value);
  };

  /**
   * 결제 금액 분할 데이터 삭제
   * @param index 삭제할 결제 분할 인덱스
   */
  const removePaymentSplit = (index: number) => {
    if (index > -1 && index < summary.value.splits.length) {
      summary.value.splits.splice(index, 1);
    }
  };

  /** 마지막 결제 금액 분할 데이터 삭제 */
  const removeLastPaymentSplit = () => {
    if (summary.value.splits.length > 0) {
      summary.value.splits.pop();
    }
  };

  return {
    summary,
    remainingAmount,

    setSummary,
    addPaymentSplit,
    removePaymentSplit,
    removeLastPaymentSplit,
  };
});
